"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _settings = require("@/api/settings");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
require("tinymce/tinymce");
require("tinymce/themes/silver");
require("tinymce/icons/default");
require("tinymce/skins/ui/oxide/skin.css");
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/paste");
require("tinymce/plugins/help");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/preview");
require("tinymce/plugins/table");
require("tinymce/plugins/code");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, _settings.defaultSettingData);
    this.loading = false;
    this.inputVisible = false;
    this.inputValue = '';
    this.inputBlacklistedEmailDomainsVisible = false;
    this.inputBlacklistedEmailDomainsValue = '';
    this.image = [];
    this.rules = {
      bankInformation: [{
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      transactionPercent: [{
        min: 0,
        max: 100,
        type: 'number',
        message: 'Percentage should be less than 100',
        trigger: 'blur'
      }],
      bookingPercent: [{
        min: 0,
        max: 100,
        type: 'number',
        message: 'Percentage should be less than 100',
        trigger: 'blur'
      }]
    };
    this.workingHoursRange = null;
  }
  onWorkingHoursRangeChange(val) {
    if (val && val.length === 2) {
      this.formData.workingHours = `${val[0]} - ${val[1]}`;
    } else {
      this.formData.workingHours = '';
    }
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    this.fetchData(1);
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id = 1) {
    try {
      const data = await (0, _settings.getSettingById)(id);
      if (data) {
        this.formData = Object.assign({}, _settings.defaultSettingData, data);
      } else {
        this.formData = Object.assign({}, _settings.defaultSettingData);
      }
      if (this.formData.featuredProductPromoImage) {
        this.image.push({
          name: data.featuredProductPromoName,
          url: data.featuredProductPromoImage
        });
      }
      if (this.formData.workingHours) {
        var _times$, _times$2;
        const times = this.formData.workingHours.split('-');
        this.workingHoursRange = [(_times$ = times[0]) === null || _times$ === void 0 ? void 0 : _times$.trim(), (_times$2 = times[1]) === null || _times$2 === void 0 ? void 0 : _times$2.trim()];
      }
      // Just for test
      const title = this.formData.id.toString();
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  imageUploaded(file) {
    this.formData.featuredProductPromoImage = file.response;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  handleClose(tag) {
    this.formData.whatsappRecipients.splice(this.formData.whatsappRecipients.indexOf(tag), 1);
  }
  showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      const tagRef = this.$refs.saveTagInput;
      tagRef.$refs.input.focus();
    });
  }
  handleInputConfirm() {
    const inputValue = this.inputValue;
    if (inputValue) {
      this.formData.whatsappRecipients.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = '';
  }
  showTagInput() {
    this.inputBlacklistedEmailDomainsVisible = true;
    this.focusTagInput();
  }
  focusTagInput() {
    this.$nextTick(() => {
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  handleTagInputConfirm(event) {
    const blacklistedEmailDomainsValue = this.inputBlacklistedEmailDomainsValue;
    if (blacklistedEmailDomainsValue) {
      let blacklistedEmailDomains = [];
      if (this.formData.blacklistedEmailDomains) {
        blacklistedEmailDomains = this.formData.blacklistedEmailDomains;
      }
      // push if not exist
      if (blacklistedEmailDomains.indexOf(blacklistedEmailDomainsValue) === -1) {
        blacklistedEmailDomains.push(blacklistedEmailDomainsValue);
      } else {
        this.$message({
          showClose: true,
          message: blacklistedEmailDomainsValue + ' already exist!',
          type: 'warning'
        });
      }
      this.formData.blacklistedEmailDomains = blacklistedEmailDomains;
    }
    this.inputBlacklistedEmailDomainsValue = '';
    // if entered
    if (event.keyCode && event.keyCode === 13) {
      this.focusTagInput();
    } else {
      this.inputBlacklistedEmailDomainsVisible = false;
    }
  }
  handleTagClose(tag) {
    const blacklistedEmailDomains = this.formData.blacklistedEmailDomains;
    blacklistedEmailDomains.splice(blacklistedEmailDomains.indexOf(tag), 1);
  }
  resetForm() {
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
  }
  async saveForm() {
    try {
      var _this$workingHoursRan;
      this.loading = true;
      if (((_this$workingHoursRan = this.workingHoursRange) === null || _this$workingHoursRan === void 0 ? void 0 : _this$workingHoursRan.length) === 2) {
        this.formData.workingHours = `${this.workingHoursRange[0]} - ${this.workingHoursRange[1]}`;
      }
      // if (this.isEdit) {
      await (0, _settings.updateSetting)(this.formData.id, this.formData);
      // } else {
      // await createSetting(this.formData)
      // }
      this.$notify({
        title: 'Success',
        message: 'Settings saved successfully',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      // router.push('/setting/info')
    } catch (err) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('workingHoursRange')], default_1.prototype, "onWorkingHoursRangeChange", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'SettingDetail',
  components: {
    HelpText: _index.default,
    FileUpload: _index2.default,
    Editor: _tinymceVue.default
  }
})], default_1);
var _default = exports.default = default_1;